import { NetworkService } from './network.service';

const services = [NetworkService];

export { services };
